export const feeMonitorSeverityToLabel = (value) => {
  if (value === null || value === undefined) return "NONE";

  if (typeof value === "string") {
    const normalized = value.toUpperCase();
    if (["NONE", "INFO", "AMBER", "RED"].includes(normalized)) return normalized;
  }

  const numeric = typeof value === "number" ? value : Number(value);
  switch (numeric) {
    case 0:
      return "NONE";
    case 1:
      return "INFO";
    case 2:
      return "AMBER";
    case 3:
      return "RED";
    default:
      return "NONE";
  }
};

export const feeMonitorFrequencyToLabel = (value) => {
  if (value === null || value === undefined) return "custom";

  if (typeof value === "string") {
    const normalized = value;
    if (["monthly", "quarterly", "halfYear", "yearly", "custom"].includes(normalized)) return normalized;
    const upper = normalized.toUpperCase();
    if (upper === "MONTHLY") return "monthly";
    if (upper === "QUARTERLY") return "quarterly";
    if (upper === "HALFYEAR") return "halfYear";
    if (upper === "YEARLY") return "yearly";
    return "custom";
  }

  const numeric = typeof value === "number" ? value : Number(value);
  // Backend enum: monthly=0, quarterly=1, halfYear=2, yearly=3, custom=4
  switch (numeric) {
    case 0:
      return "monthly";
    case 1:
      return "quarterly";
    case 2:
      return "halfYear";
    case 3:
      return "yearly";
    case 4:
      return "custom";
    default:
      return "custom";
  }
};

export const feeMonitorFrequencyToPeriodMonths = (frequency) => {
  const dominant = Number(frequency?.dominantMonths);
  // Backend can provide "dominantMonths" for custom frequencies (e.g. 2),
  // and for halfYear/year (6/12). Prefer it when valid.
  if (Number.isFinite(dominant) && dominant >= 1 && dominant <= 12) return dominant;

  const label = feeMonitorFrequencyToLabel(frequency?.label);
  switch (label) {
    case "monthly":
      return 1;
    case "quarterly":
      return 3;
    case "halfYear":
      return 6;
    case "yearly":
      return 12;
    default:
      return 3;
  }
};

export const feeMonitorFrequencyToDisplayLabel = (value) => {
  const label = feeMonitorFrequencyToLabel(value);
  switch (label) {
    case "monthly":
      return "Monthly";
    case "quarterly":
      return "Quarterly";
    case "halfYear":
      return "Half Year";
    case "yearly":
      return "Yearly";
    case "custom":
      return "Custom";
    default:
      return "Custom";
  }
};


